import { Record, Map } from "immutable";

export default Record({
  isRemoveModalVisible: false,
  isEditModalVisible: false,
  search: new (Record({
    name: ""
  }))(),
  meta: new (Record({
    all: 0,
    count: 0,
    limit: 100,
    currentPage: 0
  }))(),
  singleListMeta: new (Record({
    all: 0,
    count: 0,
    limit: 10,
    currentPage: 0
  }))(),
  singleListMetaFilms: new (Record({
    all: 0,
    count: 0,
    limit: 999,
    currentPage: 0
  }))(),
  sort: new (Record({
    isDirectionAscending: false,
    field: "createdAt"
  }))(),
  loading: false,
  entities: new Map([]),
  entitiesFilms: new Map([]),
  results: []
});



// WEBPACK FOOTER //
// ./src/common/pagesLists/pagesLists.js